import { Component, OnInit, Input } from '@angular/core';
import { Video } from './models';
import { DomSanitizer } from '@angular/platform-browser';
// import { BlipChatControlSingleton } from '../../../../../';
import Player from '@vimeo/player';

@Component({
    selector: 'learning-with-video-list',
    templateUrl: './learning-with-video-list.component.html',
    styleUrls: ['./learning-with-video-list.component.scss']
})
export class LearningWithVideosListComponent implements OnInit {
    @Input() public videoList: Video[];
    @Input() public title;
    @Input() public description;
    @Input() public currentVideoToOpen;
    @Input() public openVideoBox;

    // protected BlipChatControlSingleton = BlipChatControlSingleton;

    constructor(public sanitizer: DomSanitizer) {}

    public openVideo(video) {
        this.currentVideoToOpen = video;
        this.openVideoBox = true;
    }

    public closeVideo(video) {
        video.open = false;
    }

    public ngOnInit(): void {}
}
